import { Button, Typography } from '@breetometer/components';
import { StatusIcon } from 'BreetAssets';
import { CURRENCYCONFIG } from 'BreetHelpers';

import type { ITransactionMobileColumnRight } from '../TransactionsMobileColumn.helpers';

const MobileColumnRight = ({ amount, status, currency, onClick, children, value }: ITransactionMobileColumnRight) => (
	<Button
		variant='native'
		className='datatable_mobilecolumnright'
		onClick={onClick}
	>
		{children ?? (
			<>
				<Typography
					as='h6'
					className='color-neutral-50'
				>
					{value ?? (currency && currency in CURRENCYCONFIG ? `${CURRENCYCONFIG[currency].symbol}${amount}` : (amount ?? ''))}
				</Typography>
				<StatusIcon status={status} />
			</>
		)}
	</Button>
);

export default MobileColumnRight;
